/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_S4Inputs */

const en_tut_kantor_s4 = /** @type {(inputs: Tut_Kantor_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The **Rekan** panel on the right shows who is present and in which room. **Temukan** highlights them, **Sapa** sends a wave, **Pesan** opens a DM.`)
};

const id_tut_kantor_s4 = /** @type {(inputs: Tut_Kantor_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel **Rekan** di kanan menunjukkan siapa yang hadir dan di ruang mana. **Temukan** menyorot posisinya, **Sapa** mengirim lambaian, **Pesan** membuka DM.`)
};

/**
* | output |
* | --- |
* | "The **Rekan** panel on the right shows who is present and in which room. **Temukan** highlights them, **Sapa** sends a wave, **Pesan** opens a DM." |
*
* @param {Tut_Kantor_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_s4 = /** @type {((inputs?: Tut_Kantor_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_s4(inputs)
	return en_tut_kantor_s4(inputs)
});